// src/components/AuthPopup.js
import React, { useState } from 'react';
import HrnbModal from "../controls/HrnbModal";
import HrnbLoginForm from "./HrnbLoginForm";
import {HrnbTab, HrnbTabs} from "../controls/HrnbTabs";
import HrnbRegisterForm from "./HrnbRegisterForm";
import { LoginIcon, RegisterIcon } from "../../icons";

const AuthPopup = ({ isOpen, onClose }) => {
    const [tab, setTab] = useState("login");

    return (
        <HrnbModal open={isOpen} onClose={onClose} className="tabs-header">
            <HrnbTabs value={tab} onChange={setTab} style={{ marginBottom: 24 }}>
                <HrnbTab
                    label="Авторизация"
                    value="login"
                    icon={<LoginIcon />}/>
                <HrnbTab
                    label="Регистрация"
                    value="register"
                    icon={<RegisterIcon />}/>
            </HrnbTabs>
            {tab === "login" ? (
                <HrnbLoginForm
                    onClose={onClose}
                    onSwitchRegister={() => setTab("register")}
                />
            ) : (
                <HrnbRegisterForm
                    onClose={onClose}
                    onSwitchLogin={() => setTab("login")}
                />
            )}
        </HrnbModal>
    );
};

export default AuthPopup;